export const SECTIONS = {
  OVERVIEW: 'Overview',
  DESCRIPTION: 'Description',
  INGREDIENTS: 'Ingredients',
  SPECIFICATIONS: 'Specifications',
  TOP_OFF: 'Top-Off',
  WEIGHTS_AND_DIMENSIONS: 'Weight & Dimensions',
  TIPS_AND_HANDLING: 'Tips & Handling',
  PREPARATION_INSTRUCTIONS: 'Preparation Instructions',
  SERVING_SUGGESTIONS: 'Serving Suggestions',
  STORAGE_INSTRUCTIONS: 'Storage Instructions',
  NUTRITION_FACTS: 'Nutrition Facts',
  CLAIMS: 'Claims',
  ALLERGENS: 'Allergens',
  PRODUCT_IDENTIFIERS: 'Product Identifiers',
  CHILD_NUTRITION_FACTS: 'Child Nutrition Facts',
  ADDITIONAL_DOCUMENTS: 'Additional Documents',
  TAXONOMIES: 'Taxonomies',
};

// Matched by attribute_id (not name) because the PFS attribute's name can change over time.
export const PFS_ATTRIBUTE_ID = '151';
